<template>
  <div class="wrap">
    <head-block></head-block>
    <div class="warpInner">
      <router-view/>
    </div>
    <foot-block></foot-block>
  </div>
</template>

<script>
  import HeadBlock from "../HeadBlock/HeadBlock"
  import FootBlock from "../FootBlock/FootBlock"

  export default {
    name: "Wrap",
    components: {
      "head-block": HeadBlock,
      "foot-block": FootBlock
    },
  }
</script>

<style scoped lang="scss">
  @media screen and (min-width: $minDeviceWidth_pc) {
    .wrap{
      .warpInner{
        min-width: $minDeviceWidth_pc;
        width: 100%;
        margin: 0 auto;
      }
    }
  }
  @media screen and (max-width: $minDeviceWidth_pc) {
    .wrap{
      .warpInner{
          min-width: $minDeviceWidth_pc;
        width: 100%;
        margin: 0 auto;
      }
    }
  }
</style>
